import React from 'react';
import styled from '../../../components/styled';
import { RegularText, RichTextField } from '../../../components';

import { Snippet } from '../../../services/dataModels';
import { selectEditingMode } from '../../../store/selectors';
import { CommentSnippet, StandingOrderSnippet, TaskSnippet } from '../@snippets';

interface RowFormProps {
  values: Snippet;
  rollupIndex: number;
  rowIndex: number;
}

const RowForm = ({ values, rollupIndex, rowIndex }: RowFormProps) => {
  const path = `data[${rollupIndex}].rowData[${rowIndex}]`;
  const data = values.data[rollupIndex].rowData[rowIndex];
  const readOnly = selectEditingMode.useHook() === 'readOnly';

  switch (values.type) {
    case 'RollupComment':
    case 'Comment': {
      const value = data.Note as string;
      return readOnly ? (
        value === '' ? (
          <EmptyState>No comments</EmptyState>
        ) : (
          <Text
            value={value}
            disabled={true}
          />
        )
      ) : (
        <CommentSnippet path={`${path}.Note`} rowData={value} />
      );
    }
    case 'StandingOrder':
      return (
        <StandingOrderSnippet
          path={path}
          configuration={values.configuration.columns}
          data={data}
        />
      );
    case 'Task':
      return <TaskSnippet path={path} configuration={values.configuration.columns} data={data} />;
  }
};

export default RowForm;

const Text = styled(RichTextField)`
  min-height: 300px;
  margin: 10px 12px 5px;
  background-color: white;
  padding: 10px;
  border-width: 1px;
  border-color: transparent;
  border-radius: 4px;
  overflow: hidden;
`;

const EmptyState = styled(RegularText)`
  text-align: center;
  font-style: italic;
  color: #aaaaaa;
  margin-top: 50px;
`;
